<template>
  <div :class="$attrs.class === undefined ? `bs-callout bs-callout-${variant}` : $attrs.class">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BsCallout',
  props: {
    variant: {
      type: String,
      default: 'info'
    }
  }
}
</script>

<style>
.bs-callout {
  padding: 20px;
  margin: 20px 0;
  border: 0 solid #eee;
  border-left-width: 5px;
  border-radius: 3px;
}

.bs-callout-danger {
  border-left-color: #f0524e;
  background-color: #f5f5f5;
}

.bs-callout-warning {
  border-left-color: #f0ad4e;
  background-color: #fff3e5;
  margin-top: 0;
}

.bs-callout-info {
  border-left-color: #5bc0de;
  background-color: #e6f0f3;
}

.bs-callout-success {
  border-left-color: #269900;
  background-color: #f5f5f5;
}

.bs-callout h4 {
  margin-top: 0;
  margin-bottom: 15px;
  font-weight: bold;
}
</style>
